
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType, otherPartyInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { lastStepDataInfoType, nprOtherPartyDataInfoType } from '@/types/Application/IntentionProceed';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})

export default class Form2Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;  
   
    yourInfo = {} as yourInformationInfoDataInfoType;   
    otherPartyInfo: nprOtherPartyDataInfoType[] = [];
    additionalOtherParties: nprOtherPartyDataInfoType[] = [];
    firstOtherParty = {} as nprOtherPartyDataInfoType;
    lastStepInfo = {} as lastStepDataInfoType;

    existingFileNumber = '';  
    overOneYear = false;
    acknowledgeService = false;
   
    mounted(){
        this.dataReady = false;
        // console.log(this.result)
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){    

        this.otherPartyInfo=this.getOtherPartyInfo()        
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0,1)
            this.additionalOtherParties = this.otherPartyInfo;
        }         
        
        this.yourInfo = this.getYourInfo();        
        this.lastStepInfo = this.getLastStepInfo();
         this.result.noticeIntentionProceedSurvey?.lastStep;
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.acknowledgeService = this.result.otherPartyNprConfirmationSurvey?.confirmation == 'Confirmed';
        this.overOneYear = !this.result.noticeIntentionProceedSurvey?.unresolvedLessThanYear;
    } 

    public getYourInfo(){          

        if(this.result?.yourInformationNprSurvey){            
            return getYourInformationResults(this.result?.yourInformationNprSurvey); 
        } else {
            return {} as yourInformationInfoDataInfoType;
        }
            
    }

    public getOtherPartyInfo(){

        let OpInformation: nprOtherPartyDataInfoType[] = [];        

        if (this.result.otherPartyNprSurvey?.length > 0){
            OpInformation = [];
            const otherPartyData: otherPartyInfoType[] =  this.result.otherPartyNprSurvey;
        
            for(const party of otherPartyData){ 
                const otherParty = {} as nprOtherPartyDataInfoType;               

                if (party.knowDob == 'y' &&  party.dob)
                    otherParty.dob = party.dob

                if (party.name)
                    otherParty.name = party.name;
                
                if (party.address)
                    otherParty.address = party.address;
                
                if (party.contactInfo)
                    otherParty.contactInfo = party.contactInfo;
                
                if (party.lawyer)
                    otherParty.lawyer = party.lawyer
                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    } 

    public getLastStepInfo(){     
        
        const lastStepInfo = {
            resolveFlmDate: "",
            needsAssessmentDate: "",
            parentingEducationProgramDate: "",
            consensualDisputeResolutionDate: "",
            flmDate: "",
            selected: "",
            otherDate: "",
            otherDescription: ""
        }

        if(this.result?.noticeIntentionProceedSurvey?.lastStep && this.result?.noticeIntentionProceedSurvey?.unresolvedFlm == 'y'){  
            
            const lastStepData = this.result?.noticeIntentionProceedSurvey?.lastStep;
            lastStepInfo.selected = lastStepData.selected;
            if (lastStepInfo.selected == 'resolveFlm'){
                lastStepInfo.resolveFlmDate = lastStepData.resolveFlmDate;

            } else if (lastStepInfo.selected == 'parentingEducationProgram'){
                lastStepInfo.parentingEducationProgramDate = lastStepData.parentingEducationProgramDate;

            } else if (lastStepInfo.selected == 'needsAssessment'){
                lastStepInfo.needsAssessmentDate = lastStepData.needsAssessmentDate;

            } else if (lastStepInfo.selected == 'flm'){
                lastStepInfo.flmDate = lastStepData.flmDate;

            } else if (lastStepInfo.selected == 'consensualDisputeResolution'){
                lastStepInfo.consensualDisputeResolutionDate = lastStepData.consensualDisputeResolutionDate;

            } else if (lastStepInfo.selected == 'other'){
                lastStepInfo.otherDate = lastStepData.otherDate;
                lastStepInfo.otherDescription = lastStepData.otherDescription
            }
            
        }

        return lastStepInfo;
    
    }    
 
}
